import axios from '@/lib/axios';
import { PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1010. 支払タスクフェーズ更新（次へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:id/move_to_next_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  current_payment_task_phase_id: number;
};

const movePaymentTaskPhaseToNext = (props: Props): Promise<PaymentTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/move_to_next_phase`,
    props
  );
};

export const useMovePaymentTaskPhaseToNext = () => {
  return useMutation({
    mutationFn: movePaymentTaskPhaseToNext,
  });
};
